import en from './locales/en.json';
import es from './locales/es.json';
import th from './locales/th.json';
import tr from './locales/tr.json';

export const translations = {
  en,
  es,
  th,
  tr
};

export const languageNames = {
  en: { name: "English", native: "English", flag: "🇬🇧" },
  es: { name: "Spanish", native: "Español", flag: "🇪🇸" },
  th: { name: "Thai", native: "ไทย", flag: "🇹🇭" },
  tr: { name: "Turkish", native: "Türkçe", flag: "🇹🇷" }
};

export const getLanguageName = (code) => {
  return languageNames[code]?.native || languageNames[code]?.name || code;
};
